import { Action, any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { previousOrDefault } from "../../../../custom_api/api_utils";
import { TextWith4Covers, themeSearch } from "../../../../custom_api/collection/api";
import { CollectionPageProps } from "../../../pages/collection_page";
import { pushThemeBasedInspirationAction } from "../../datalayer";
import { history } from "../../history";
import { scrollAdviceIntoView } from "../Advice/Advice";
import { ThemeBasedInspirationLayoutKiosk } from "./ThemeBasedInspirationLayoutKiosk";
import { ThemeBasedInspirationLayoutWeb } from "./ThemeBasedInspirationLayoutWeb";
import { ThemeBasedInspirationLayoutProps, ThemeBasedInspirationState } from "./ThemeBasedInspirationState";
import debounce = require("lodash.debounce")
import { SearchOn } from "../../../../custom_api/collection/types";

type Updater = (_: Action<ThemeBasedInspirationState>) => void

export const ThemeBasedInspirationWidget = (props: ThemeBasedInspirationState) => {
  return any<Action<ThemeBasedInspirationState>>({ key: `Theme-based` })([
    fromJSX((setState) => {
      const layoutProps: ThemeBasedInspirationLayoutProps = {
        ...props,
        updateSearchQuery: (searchQuery: string) => {
          updateSearchQuery(setState, searchQuery)
          debouncedSearchResults(setState, searchQuery)
          debouncedSearchQueryAction(searchQuery)
        },
        pickTheme: (theme) => {
          pushThemeBasedInspirationAction("Zoek resultaat uit", theme.label)
          history.push(`/${props.routePath}/thema/${theme.label}`);
          scrollAdviceIntoView();
        },
        pushDataLayer: (action: string, label: string) => {
          debouncedDataLayerAction(action, label)
        }
      }
      return props.isKioskMode
        ? ThemeBasedInspirationLayoutKiosk(layoutProps)
        : ThemeBasedInspirationLayoutWeb(layoutProps)
    }),

    // Handle loading of searched books
    async<SearchOn[]>(nothing, { key: 'resultLoader'})(props.searchResults).map(updater => s0 => ({...s0, searchResults: updater(s0.searchResults)})),
    async<TextWith4Covers[]>(nothing, { key: 'PopularThemeBasedPromptsLoader' })(props.popularThemes)
      .map(resultUpdater => s0 => {
        const popularThemes = resultUpdater(s0.popularThemes)
        return ({ ...s0, popularThemes })
      }),
    async<CollectionPageProps>(nothing, { key: 'collectionPageLoader' })(props.collectionPage)
      .map(resultUpdater => s0 => {
        const collectionPage = resultUpdater(s0.collectionPage)
        return ({ ...s0, collectionPage })
      })
  ]).map(a => a(props))
}

const updateSearchQuery = (set: Updater, searchQuery: string) => { set((prev) => ({...prev, searchQuery})) }

const loadSearchResults = (set: Updater, searchQuery: string) => { set((prev) =>({
  ...prev,
  searchResults: loadingAsyncState(themeSearch(searchQuery.trim()), previousOrDefault(prev.searchResults, []))
}))}

const debouncedSearchResults = debounce((update: Updater, searchQuery: string) => loadSearchResults(update, searchQuery), 200)
const debouncedDataLayerAction = debounce((action: string, label: string) => pushThemeBasedInspirationAction(action, label), 1000)
const pushSearchQueryAction = (searchQuery: string) => pushThemeBasedInspirationAction("Zoeken", searchQuery)
const debouncedSearchQueryAction = debounce((s: string) => pushSearchQueryAction(s), 1500)